import { Body } from '@service-victoria/component-library/components/Text/Body';
import colors from '@service-victoria/component-library/utils/colors';
import device from '@service-victoria/component-library/utils/device';
import styled from 'styled-components';

export const CallToActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 48px;

  > button + button {
    margin-top: 24px;
  }

  @media ${device.isTabletAndAbove} {
    flex-direction: row-reverse;

    > button {
      & + button {
        margin-top: 0;
        margin-right: 24px;
      }
    }
  }
`;

export const Separator = styled(Body).attrs({ as: 'span', fontWeight: 600 })`
  display: block;
  height: 24px;
  background-color: ${colors.blueGrey10};
  padding: 4px 12px;
`;

export const AccordionItemContainer = styled.form`
  padding: 10px 5px;

  @media ${device.isDesktop} {
    padding: 20px 35px;
  }
`;

export const FocusedOverlay = styled.div`
  position: fixed;
  inset: 0px;
  background-color: rgba(142, 144, 147, 0.6);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 999;
`;
